<template>
  <div class="Home">
    <Banner />
    <About />
    <Highlights />
    <!-- <Regtech/> -->
    <!-- <Why/> -->
    <Solutions />
    <Features />
    <Industries />
    <!-- <Verticals /> -->
    <Work />
    <!-- <Community/> -->
    <Alies />
  </div>
</template>

<script>
import Banner from "./Banner";
import Highlights from "./Highlights";
import About from "./About";
import Alies from "./Alies";
// import Community from './Community'
// import Regtech from './Regtech'
import Solutions from "./Solutions";
// import Verticals from "./Verticals";
import Industries from "./Industries";
// import Why from './Why'
import Work from "./Work";
import Features from "./Features";

import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "Home",
  components: {
    Banner,
    Highlights,
    About,
    Alies,
    // Community,
    // Regtech,
    Solutions,
    // Verticals,
    Industries,
    // Why,
    Work,
    Features,
  },
  created() {
    AOS.init({
      // Global settings:
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
    });
  },
};
</script>
